// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gC4Kv","top":"styles_top__3X2u6","left":"styles_left__1wf2w","description":"styles_description__2auT3"};